
import { addDoc, collection, deleteDoc, doc, getDoc, getDocs, getFirestore, setDoc, updateDoc } from 'firebase/firestore';
import { SHOP } from '../entities/Shop';
import { ticketFieldConverter, TICKET_FIELD } from '../entities/TicketField';
import firebase from '../firebase/Firebase';

const store = getFirestore(firebase);

export const getTicketField = async (shopId: string, ticketFieldId: string) => {
  const shopRef = doc(store, SHOP, shopId)
  const fieldRef = doc(shopRef, TICKET_FIELD, ticketFieldId).withConverter(ticketFieldConverter);
  return await getDoc(fieldRef).then((doc) => {
    return doc.data()
  }).catch((error) => {
    console.warn(error);
    return null
  });
};

export const getTicketFields = async (shopId: string) => {
  if (!shopId) return

  const shopRef = doc(store, SHOP, shopId)
  const fieldsRef = collection(shopRef, TICKET_FIELD).withConverter(ticketFieldConverter);
  return await getDocs(fieldsRef).then((snap) => {
    return snap.docs.map((doc) => doc.data())
  }).catch((error) => {
    console.warn(error);
    return null
  });
};

export const addTicketField = async (shopId: string, field) => {
  const shopRef = doc(store, SHOP, shopId);
  return addDoc(
      collection(shopRef, TICKET_FIELD).withConverter(ticketFieldConverter), field
    ).then((ref) => {
      return ref.id;
    }).catch((err) => {
      console.warn(err);
      return null
    });
}

export const setTicketField = async (shopId: string, field) => {
  const shopRef = doc(store, SHOP, shopId);
  return setDoc(
    doc(collection(shopRef, TICKET_FIELD), field.id).withConverter(ticketFieldConverter), field
  ).catch((err) => {
    console.warn(err);
    return null
  });
}

export const updateTicketField = async (shopId: string, field) => {
  const shopRef = doc(store, SHOP, shopId);
  return updateDoc(
    doc(collection(shopRef, TICKET_FIELD), field.id).withConverter(ticketFieldConverter), field
  ).catch((err) => {
    console.warn(err);
    return null
  });
}

export const deleteTicketField = async (shopId: string, field) => {
  const shopRef = doc(store, SHOP, shopId);
  return deleteDoc(
    doc(collection(shopRef, TICKET_FIELD), field.id)
  ).catch((err) => {
    console.warn(err);
    return null
  });
}